import apiRequestService from '@/commonProject/service/apiRequestService';

export default class counselorProfileRepository {
    /**
     * カウンセラープロフィール取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getCounselorProfileApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/coudtl', requestBody, idToken);
        return result;
    }
    /**
     * カウンセラープロフィール画像取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getCounselorProfileImageApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/coupho', requestBody, idToken);        
        return result;
    }
}
